import { createContext } from 'react';
import initialSuperAdminState from './initialSuperAdminState';

const SuperAdminContext = createContext(initialSuperAdminState);

export default SuperAdminContext;
